import React, { memo } from 'react';

interface FrozenProps {
  color?: string;
  size?: number;
}

function Frozen({ color = '#666666', size = 14 }: FrozenProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M9 9V10H8V9H9Z" fill={color} />
      <path
        d="M11 12V6C11 4.34 9.66 3 8 3C6.34 3 5 4.34 5 6V12C3.79 12.91 3 14.37 3 16C3 17.12 3.38 18.14 4 18.97V19H4.02C4.93 20.21 6.37 21 8 21C9.63 21 11.06 20.21 11.98 19H12V18.97C12.62 18.14 13 17.12 13 16C13 14.37 12.21 12.91 11 12ZM5 16C5 15.06 5.45 14.16 6.2 13.6L7 13V6C7 5.45 7.45 5 8 5C8.55 5 9 5.45 9 6H8V7H9V13L9.8 13.6C10.55 14.17 11 15.06 11 16H5Z"
        fill={color}
      />
      <path
        d="M22 8.05H20.1235L21.5815 6.592L20.947 5.953L18.85 8.05H17.95V7.15L20.047 5.053L19.408 4.4185L17.95 5.8765V4H17.05V5.8765L15.592 4.4185L14.953 5.053L17.05 7.15V8.05H16.15L14.053 5.953L13.4185 6.592L14.8765 8.05H13V8.95H14.8765L13.4185 10.408L14.053 11.047L16.15 8.95H17.05V9.85L14.953 11.947L15.592 12.5815L17.05 11.1235V13H17.95V11.1235L19.408 12.5815L20.047 11.947L17.95 9.85V8.95H18.85L20.947 11.047L21.5815 10.408L20.1235 8.95H22V8.05Z"
        fill={color}
      />
    </svg>
  );
}

export default memo(Frozen);
